 import { markAsInstalled, storeAddToHomeScreenEvent, clearInstallEvent } from '../store/actions/addToHomeScreen';
 
 const registerAddToHomeScreen = dispatch => {
    if(process.env.NODE_ENV !== 'development') {
        if(navigator && navigator.standalone) {
            dispatch(markAsInstalled());
        }
        else if(matchMedia && matchMedia('(display-mode: standalone)').matches) {
            dispatch(markAsInstalled());
        }
        else {
            const handleBeforeInstallPrompt = event => {
                dispatch(storeAddToHomeScreenEvent(event));

                event.userChoice.then(choiceResult => {
                    if(choiceResult === 'accepted') {
                        dispatch(markAsInstalled());
                    }
                    else {
                        dispatch(clearInstallEvent());
                    }
                });
                
                window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            };

            window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        }
    }
};

export default registerAddToHomeScreen;